import api from "./api";

export const binService = {
  // Get user's bin
  getUserBin: async () => {
    const response = await api.get("/bin");
    return response.data;
  },

  // Add material to bin
  addToBin: async (materialData) => {
    const response = await api.post("/bin/add", materialData);
    return response.data;
  },

  // Update material quantity in bin
  updateBinItem: async (itemId, newQuantity) => {
    const response = await api.put(`/bin/update`, { itemId, newQuantity });
    return response.data;
  },

  // Remove material from bin
  removeFromBin: async (itemId) => {
    const response = await api.delete(`/bin/remove/${itemId}`);
    return response.data;
  },

  // Clear entire bin
  clearBin: async () => {
    const response = await api.delete("/bin");
    return response.data;
  },

  // Assign agent to bin
  assignAgent: async (agentId) => {
    const response = await api.post("/bin/select-agent", { agentId });
    return response.data;
  },
};
